/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNotNullTimestamp: core.serialization.ObjectSchema<
    serializers.IsNotNullTimestamp.Raw,
    Truvity.IsNotNullTimestamp
> = core.serialization.object({});

export declare namespace IsNotNullTimestamp {
    export interface Raw {}
}
